export default __webpack_public_path__ + "static/media/Stag-Sans-Bold-Italic.875c0aea.otf";